export default {
  container: {
    color: '#666666',
    fontSize: 14,
  },
  button: {
    textTransform: 'none',
  },
  infoBox: {
    p: 2,
    my: 2,
    border: 1,
    borderColor: '#e2a33633',
    bgcolor: '#e2a3361a',
    borderRadius: 2,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: 2,
    textAlign: 'center',
  },
  infoBoxTitle: {
    fontSize: 'inherit',
    fontWeight: 600,
    color: '#1a1a1a',
  },
  infoBoxText: {
    fontSize: 13,
  },
  giftIconColor: {
    color: '#29a36a',
    fontSize: 20,
  },
  dropzone: {
    mt: 2,
    p: 3,
    textAlign: 'center',
    border: '1px dashed #d4d7de',
    borderRadius: 2,
    backgroundColor: '#fafafb',
    color: '#999999',
    cursor: 'pointer',
  },
  dropzoneIcon: {
    fontSize: 34,
    color: '#aab0bb',
  },
  dropzoneText: {
    color: '#666666',
    fontSize: 'inherit',
    maxWidth: 420,
    mx: 'auto',
    mb: 1.5,
  },
  browseButton: {
    border: 0,
    p: 0,
    m: 0,
    bgcolor: 'transparent',
    textDecoration: 'underline',
    color: '#1A5787',
    cursor: 'pointer',
    fontSize: 'inherit',
  },
  dropzoneMeta: {
    fontSize: 12,
  },
  dropzoneMetaPrimary: {
    fontSize: 12,
    mb: 0.5,
  },
  selectedFilesCard: {
    mt: 1.5,
    p: 1.5,
    border: '1px solid #e4e7ec',
    borderRadius: 2,
    backgroundColor: '#fcfcfd',
  },
  selectedFilesTitle: {
    color: '#1a1a1a',
    fontWeight: 600,
    fontSize: 'inherit',
  },
  selectedFilesMeta: {
    color: '#666666',
    fontSize: 12,
    mt: 0.25,
    mb: 1,
  },
  selectedFilesList: {
    maxHeight: 180,
    overflowY: 'auto',
    border: '1px solid #eceef2',
    borderRadius: 1.5,
    p: 1,
    backgroundColor: '#ffffff',
  },
  selectedFileName: {
    color: '#1a1a1a',
    fontSize: 13,
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectedFileSize: {
    color: '#999999',
    fontSize: 12,
    flexShrink: 0,
    minWidth: 52,
    textAlign: 'right',
  },
  removeFileButton: {
    textTransform: 'none',
    minWidth: 0,
    px: 0.75,
    py: 0.15,
    fontSize: 12,
  },
  clearButton: {
    textTransform: 'none',
    minWidth: 0,
    px: 1,
  },
  imagePreviewRow: {
    mb: 1,
  },
  imagePreviewItem: {
    position: 'relative',
    width: 44,
    height: 44,
    borderRadius: 1,
    overflow: 'hidden',
    border: '1px solid #e4e7ec',
    flexShrink: 0,
  },
  imagePreviewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  imagePreviewRemoveButton: {
    position: 'absolute',
    top: 2,
    right: 2,
    width: 16,
    height: 16,
    border: 0,
    borderRadius: '50%',
    lineHeight: 1,
    p: 0,
    fontSize: 12,
    color: '#ffffff',
    backgroundColor: 'rgba(0, 0, 0, 0.62)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.78)',
    },
  },
  templateCard: {
    mt: 2,
    p: 2,
    border: '1px solid #e4e7ec',
    borderRadius: 2,
    backgroundColor: '#f8f8f7',
  },
  templateTitle: {
    fontWeight: 600,
    fontSize: 'inherit',
    color: '#1a1a1a',
  },
  templateTitleIcon: {
    color: '#1A5787',
    fontSize: 20,
  },
  templateRecommendationTitle: {
    mt: 2,
    mb: 1.5,
    fontWeight: 600,
    color: '#1a1a1a',
    fontSize: 13,
  },
  templatePill: {
    px: 1.5,
    py: 0.4,
    borderRadius: 10,
    border: '1px solid #d8dde5',
    color: '#1a1a1a',
    fontSize: 13,
    backgroundColor: '#f5f6f8',
  },
  templateInfoIcon: {
    fontSize: 16,
  },
  templateHelperText: {
    fontSize: 12,
  },
  templateHelperRow: {
    mt: 1.5,
  },
  sectionDivider: {
    my: 2.5,
  },
  aiHeader: {
    mb: 1,
  },
  aiHeaderIcon: {
    color: '#c89a3d',
    fontSize: 18,
  },
  aiTitle: {
    fontSize: 'inherit',
    fontWeight: 500,
    color: '#1a1a1a',
  },
  aiOptional: {
    fontSize: 13,
    color: '#666666',
  },
  aiDescription: {
    fontSize: 13,
    mb: 1.5,
  },
  optionControl: {
    alignItems: 'flex-start',
    mb: 2,
  },
  optionTitle: {
    fontSize: 14,
    color: '#1a1a1a',
    fontWeight: 500,
  },
  optionDescription: {
    fontSize: 13,
  },
  aiConfirmation: {
    color: '#999999',
    fontStyle: 'italic',
    fontSize: 13,
  },
  notesTitle: {
    fontSize: 'inherit',
    fontWeight: 500,
    color: '#1a1a1a',
    mb: 1,
  },
  notesOptional: {
    fontSize: 13,
    color: '#666666',
  },
  notesInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
    '& .MuiInputBase-input': {
      fontSize: 13,
    },
  },
  postSubmissionDialog: {
    textAlign: 'center',
    color: '#1a1a1a',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
};
